import { connect } from 'react-redux'
import { User } from '../../selectors'

function mapStateToProps(state) {
  return {
    authenticated: User.authenticated(state)
  }
}

export default connect(mapStateToProps)



// WEBPACK FOOTER //
// ./client/modules/user/components/AuthenticatedRoute/enhancers.js